/* refresh search results via Ajax
 ========================================================================== */
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import toggleWishlistItem from '../product/wishlist';
import addState from '../states/index';
import analytics from '../../analytics';
import { setHTMLWithScripts } from '../../utils';
import showLoader from '../loader';
import { cmsBlockProduct as sliderCmsBlockProduct } from '../sliders/sliders';
import addLazyLoad from '../lazyLoad';
import { addSearch } from './lastSearch';
import { renderProductCta } from '../product/cta/ProductCta';
let currentSearch = '';
let currentController = null;
export const updateSearchResults = (input, target, resultsPath) => {
    if (!target) {
        return;
    }
    const searchTerm = input.value.trim();
    if (!searchTerm) {
        return;
    }
    const value = encodeURIComponent(searchTerm);
    if (currentSearch === value) {
        return; // Avoid double trigger
    }
    currentSearch = value;
    if (currentController) {
        currentController.abort();
    }
    currentController = new AbortController();
    const hideSuggestions = document.querySelector('[data-search-helpers]');
    if (hideSuggestions) {
        hideSuggestions.classList.add('hidden');
    }
    const hideLoader = showLoader(target, { className: 'c-loader c-loader--large mt-8 lg:mt-18' });
    fetch(`${resultsPath}?q=${value}`, { signal: currentController.signal })
        .then((response) => response.text())
        .then((html) => {
        setHTMLWithScripts(target, html);
        addSearch(searchTerm);
        addLazyLoad();
        toggleWishlistItem();
        addState();
        sliderCmsBlockProduct();
        renderProductCta();
        analytics.productsSearched(value, document.querySelectorAll('[data-testid="block-product"]').length);
        analytics.productListViewed('Search page');
    })
        .catch((err) => {
        if (err instanceof Error && err.name === 'AbortError') {
            return;
        }
        console.error('Search error:', err);
    })
        .finally(hideLoader);
};
export default function ajaxSearch() {
    const input = document.querySelector('[data-search-input]');
    const button = document.querySelector('[data-search-button]');
    if (!input || !button) {
        return;
    }
    const targetSelector = input.dataset.productSearchTarget;
    const resultsPath = input.dataset.productSearchPath;
    if (!targetSelector || !resultsPath) {
        return;
    }
    const target = document.querySelector(targetSelector);
    if (!target) {
        return;
    }
    input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
            updateSearchResults(input, target, resultsPath);
        }
    });
    button.addEventListener('click', () => {
        updateSearchResults(input, target, resultsPath);
    });
}
